<template>
  <div
    class="profile-panel-no-items"
    v-if="externalNftsList.data?.length === 0 && !loadingNfts"
  >
    <h3 class="profile-panel-no-items-title">No Items Found</h3>
    <p class="profile-panel-no-items-text">
      {{ profilePanelNoItemsText }}
    </p>
    <p class="profile-panel-no-items-text">
      {{ profilePanelNoItemsTextLineTwo }}
    </p>
    <app-button
      buttonClass="create-nft-button"
      text="Create new NFT"
      @click.prevent="openMintingForm()"
    ></app-button>
  </div>
  <div
    class="profile-panel-body-content"
    v-if="externalNftsList.data?.length > 0"
  >
    <div v-for="(card, index) in externalNftsToShowList" :key="index">
      <nft-card :token="card"></nft-card>
    </div>
  </div>
  <app-loader v-if="loadingNfts" :isGreen="true"></app-loader>
  <app-button
    v-if="
      (externalNftsList.hasNextPage || externalNftDataList.length > 0) &&
      !loadingNfts
    "
    text="Load more"
    class="load-more-button"
    @click.prevent="loadMoreExternal()"
  ></app-button>
</template>

<script>
import { useStore } from "vuex";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import NftCard from "@/components/NftCard";
import AppButton from "@/elements/AppButton";
import AppLoader from "@/elements/AppLoader";
import useProfilePanels from "@/composables/useProfilePanels";
export default {
  components: {
    AppButton,
    AppLoader,
    NftCard,
  },
  setup() {
    const store = useStore();

    const {
      externalNftsList,
      externalNftDataList,
      externalNftsToShowList,
      profilePanelNoItemsText,
      profilePanelNoItemsTextLineTwo,
      loadMoreExternal,
      params,
      loadingNfts,
      toggleFilter,
    } = useProfilePanels(store);

    const router = useRouter();
    const openMintingForm = () => {
      store.dispatch("minting/resetState");
      store.dispatch("tagsValues/resetState");
      router.push("/");
    };

    const goToNftDetails = (nftId) => {
      router.push({ name: "NftDetails", params: { id: nftId } });
      store.dispatch("nftDetails/resetState");
    };
    onMounted(() => {
      store.dispatch("userProfile/clearExternalNftList");
      toggleFilter("filterCreated");
    });

    return {
      externalNftsList,
      externalNftDataList,
      externalNftsToShowList,
      profilePanelNoItemsText,
      profilePanelNoItemsTextLineTwo,
      openMintingForm,
      loadMoreExternal,
      params,
      loadingNfts,
      goToNftDetails,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/profilePanels.scss"></style>
